import type { Channel } from '@/Enums/Channel.enum';
import { isGamChannel } from '@/constants/forecaster';
import GamProductSelection from '@/pages/Forecaster/GamProductSelection';
import DefaultProductSelection from './DefaultProductSelection';

interface IProps {
  currentChannel: Channel;
}

// GAM uses a distinct Inventory / Ad Units layout sourced live from GAM;
// every other channel uses the default package/publisher layout.
const ProductSelection = ({ currentChannel }: IProps) =>
  isGamChannel(currentChannel) ? (
    <GamProductSelection currentChannel={currentChannel} />
  ) : (
    <DefaultProductSelection currentChannel={currentChannel} />
  );

export default ProductSelection;
